import EntitiesListFilterContainer from './entities_list_filter_container';

const EntitiesListFilter = EntitiesListFilterContainer;

export default EntitiesListFilter;
